// 槟城州球场数据
// Penang Golf Courses

export const PENANG_COURSES = {
  "BUKIT_JAWI_GOLF_RESORT": {
    shortName: "BJGR",
    fullName: "Bukit Jawi Golf Resort",
    location: ["Bukit Mertajam", "Penang", "Malaysia"],
    pars: [4,3,4,4,4,5,4,3,5, 5,4,3,4,3,5,3,4,5],
    index: [7,15,3,17,1,11,9,13,5, 10,14,16,4,18,2,12,8,6]
  },

  "BUTTERWORTH_GOLF_CLUB": {
    shortName: "BGC",
    fullName: "Butterworth Golf Club",
    location: ["Butterworth", "Penang", "Malaysia"],
    pars: [4,4,5,3,4,4,5,3,4]
  },

  "MOUNTAIN_VIEW_GOLF_RESORT": {
    shortName: "MVGR",
    fullName: "Mountain View Golf Resort",
    location: ["Sungai Jawi", "Pulau Pinang", "Malaysia"],
    pars: [4,3,5,4,4,4,3,4,5, 4,5,4,3,4,4,3,4,5],
    index: [15,17,13,9,7,5,11,1,3, 18,12,8,16,6,2,10,14,4]
  },

  "PENANG_GOLF_CLUB": {
    shortName: "PGC",
    fullName: "Penang Golf Club",
    location: ["George Town", "Penang", "Malaysia"],
    pars: [4,4,5,4,3,5,4,3,4, 4,4,5,3,4,3,5,4,4],
    index: [5,1,15,9,17,3,7,13,11, 6,10,4,14,12,18,2,8,16]
  },

  "PENANG_GOLF_RESORT": {
    shortName: "PGR",
    fullName: "Penang Golf Resort",
    location: ["Kepala Batas", "Penang", "Malaysia"],
    pars: [4,5,4,4,3,4,3,4,5, 5,4,3,4,4,4,5,3,4],
    index: [17,1,13,3,9,15,11,5,7, 6,16,18,8,2,4,14,12,10]
  },

  "PENANG_TURF_CLUB_GOLF_SECTION": {
    shortName: "PTCGS",
    fullName: "Penang Turf Club Golf Section",
    location: ["George Town", "Penang", "Malaysia"],
    pars: [4,3,5,3,4,3,4,3,4],
    index: [3,7,2,5,1,9,4,8,6]
  }
};

export default PENANG_COURSES;
